import { Component, HostListener, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AuthService } from 'src/app/shared/auth.service';
import { NavigationStart, NavigationCancel, NavigationEnd, NavigationError, Router } from "@angular/router";
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EventService } from 'src/app/shared/event.service';
import { CommonEvents, FeatureFlags } from 'src/app/shared/app.constant';
import { PermissionService } from '../../shared/permission.service';
import { FeatureFlagService } from 'src/app/commonservice/featureflag.service';
import { FirmDetailService } from 'src/app/settings/firm-details/firm-detail.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject, Subscription, timer } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DMS_PROVIDER_TYPE } from 'src/app/Models/dms-provider.model';
import { IMANAGE_PROVIDER_PORTAL_URL } from 'src/app/Models/dms-provider.constants';
import { CommonService } from 'src/app/shared/common.service';
import { XeroService } from 'src/app/settings/connections/xero/xero.service';
import { ToastrService } from 'ngx-toastr';

interface practices {
  firmDetailId: number;
  accountingFirmId: number;
  firmName: string;
  firmLogo: string;
  lastLogin: string;
  favorite?: boolean;
  tenants?: string;
  id?: number;
  dbkey?: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit, OnDestroy {
  @ViewChild('Dashboardpopup', { static: true }) public Dashboardpopup: ModalDirective;
  @ViewChild('menuTrigger', { static: true }) public menuTrigger: MatMenuTrigger;
  @ViewChild('selectPracticePopup', { static: true }) public selectPracticePopup: any;
  active: boolean = true;
  menuPermissions: any = [];
  public Clientprivilege: any;
  public Jobsprivilege: any;
  public Planningprivilege: any;
  public Docprivilege: any;
  public Timesheetprivilege: any;
  public Billingprivilege: any;
  public Reportingprivilege: any;
  public Settingsprivilege: any;
  privilege = [];
  text1: any;
  showClientSubTab: boolean = false;
  sclientlist: boolean = true;
  snewclientlist: boolean = true;
  sPlanning: boolean = true;
  userName: any;
  sBilling: boolean = true;
  sWIPView: boolean = true;
  aTimesheet: boolean = true;
  uTimesheet: boolean = true;
  sSettings: boolean = true;
  sReporting: boolean = true;
  sDocpriv: boolean = true;
  sJobspriv: boolean = true;
  isFeature: boolean = false;
  isClientFeature: boolean = false;
  isSettingFeature: boolean = false;
  isTimeSheetFeature: boolean = false;
  isWorkFlowFeature: boolean = false;
  isNewBillingFeature: boolean = false;
  isATOFeature: boolean = false;
  isWorkflowBetaFeature: boolean = false;
  public Recentpractices: practices[] = [];
  public Allpractices: practices[] = [];
  public _timesheeturl: string = '/manageprofile/timeSheet';
  private sub = new Subscription();
  unsubscribe = new Subject<void>();
  isClientListActive = false;
  isClientContactActive = false;
  isClientClassicActive = false;
  isClientClassicFeature: boolean = false;
  isBillingBetaFeature: boolean = false;
  isJobProfileActive = false;
  isJobListActive = false;
  dmsProviderKeys: any;
  public bsModalRef: BsModalRef;
  private routerSub: Subscription;
  private pendingNavigationUrl: string | null = null;
  showShortcutHints = false;
  isSidebarInteractive = false;
  isBillingShortcutOpen = false;
  isBillingBetaShortcutOpen = false;
  isPaymentShortcutOpen = false;
  isBillingMenuHovered = false;
  isBillingBetaMenuHovered = false;
  isBillingFlyoutUpward = false;
  billingFlyoutStyle: { [key: string]: string } = {};
  billingBetaFlyoutStyle: { [key: string]: string } = {};
  isBillingBetaFlyoutUpward = false;
  activeBillingMenu: 'billing' | 'beta' = 'billing';
  private billingShortcutArmed = false;
  private billingShortcutTimer: ReturnType<typeof setTimeout> | null = null;
  private billingHoverCloseTimer: ReturnType<typeof setTimeout> | null = null;
  private billingBetaHoverCloseTimer: ReturnType<typeof setTimeout> | null = null;
  public isBillingPaymentEnabled: boolean = false;

  constructor(private auth: AuthService,
    private router: Router,
    private eventService: EventService,
    private permissionService: PermissionService,
    private featureFlagService: FeatureFlagService,
    private firmDetailService: FirmDetailService,
    public modalService: BsModalService,
    private commonService: CommonService, private xeroService: XeroService, private _toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.initializeSidebar();
    this.setFeatureFlags();
    this.handleRouterEvents();
  }

  handleRouterEvents() {
    // Handle initial page load/refresh by highlighting the tab based on the current URL.
    const url = this.router.url;
    this.setTabHighlighting(url);

    // Listen for route changes (navigation, browser back/forward, etc.) and update the selected tab when navigation completes.
    this.routerSub = this.router.events
      .subscribe((event) => {

         //This is to hide the submenu shortcut when user navigates to another page using browser back/forward buttons or any other navigation method.
        if (event instanceof NavigationStart) {
          this.clearBillingShortcutArm();
        }

        if (event instanceof NavigationEnd) {
          const url = event.urlAfterRedirects;
          window.dispatchEvent(new Event('clear-quick-search'));
          this.setTabHighlighting(url);
        }

        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.pendingNavigationUrl = null;
        }
      });
  }

  setTabHighlighting(url: string) {
    this.isClientContactActive = url.includes('/client/contact');
    const isClientActive = url.includes('/client/clientlist') || url.includes('/client/groups') || url.includes('/client/contacts');
    this.isClientListActive = isClientActive && !this.isClientContactActive;
    this.isClientClassicActive = url.includes('/client/client-classic');
    this.isJobProfileActive = url.includes('/job/jobprofile');
    this.isJobListActive = (url || '')?.startsWith('/job');
    if (url.startsWith('/billing/billing-details')) {
      this.activeBillingMenu = 'beta';
    } else if (url.startsWith('/billing/billings')) {
      this.activeBillingMenu = 'billing';
    }
  }

  onMenuNavigationClick(event: MouseEvent, targetUrl: string): boolean {
    if (!this.isSidebarInteractive) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    const normalizedTargetUrl = this.normalizeNavigationUrl(targetUrl);
    const normalizedCurrentUrl = this.normalizeNavigationUrl(this.router.url);

    if (normalizedTargetUrl === normalizedCurrentUrl || normalizedTargetUrl === this.pendingNavigationUrl) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    this.pendingNavigationUrl = normalizedTargetUrl;
    this.commonService.startNewNavigation();
    return true;
  }

  onBillingNavigationClick(event: MouseEvent, targetUrl: string, menu: 'billing' | 'beta'): boolean {
    if (this.isSidebarInteractive) {
      this.activeBillingMenu = menu;
    }
    return this.onMenuNavigationClick(event, targetUrl);
  }

  private normalizeNavigationUrl(url: string): string {
    const hashTrimmed = (url || '').split('#')[0];
    const [pathPart, queryPart] = hashTrimmed.split('?');
    const normalizedPath = (pathPart || '').replace(/\/$/, '') || '/';
    return queryPart ? `${normalizedPath}?${queryPart}` : normalizedPath;
  }

  private initializeSidebar() {
    // Wait for valid permissions before initializing sidebar data
    this.sub.add(
      this.permissionService.permissionSet$.pipe(
        filter(userPermissions => userPermissions != null && userPermissions.length > 0),
        takeUntil(this.unsubscribe)
      ).subscribe((userPermissions) => {
        this.menuPermissions = userPermissions;
        this.OnpermissionSet();
        this.GetPracticeTimesheetdeatil();
        this.listenToTimesheetUpdates();
        this.getDMSProvider(); // Dev: Thiruka naik, Sandesh ; Date: 06-05-2024,  Sharepoint
        this.GetPracticesCountbyEmail1();
      })
    );
  }

  listenToTimesheetUpdates() {
    this.eventService.getEvent(CommonEvents.TIMESHEET_UPDATE).pipe(takeUntil(this.unsubscribe)).subscribe(async res => {
      if (res) {
        await this.GetPracticeTimesheetdeatil();
      }
    });
  }

  GetPracticesCountbyEmail1() {
    this.isSidebarInteractive = false;
    this.firmDetailService.GetPracticesCountByUseremail().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (result) => {
        // Always assign the data, even if empty arrays
        this.Recentpractices = result?.recentPractices || [];
        this.Allpractices = result?.allPractices || [];

        const accountingFirmId = localStorage.getItem('AccountFirmId');
        if (accountingFirmId && this.Allpractices.length > 0) {
          const hasFavorite = this.Allpractices.some(practice => practice.favorite === true);
          if (!hasFavorite) {
            const matchingIndex = this.Allpractices.findIndex(practice =>
              practice.accountingFirmId === parseInt(accountingFirmId)
            );
            if (matchingIndex !== -1) {
              this.Allpractices[matchingIndex].favorite = true;
              // Trigger change detection by creating new array reference
              this.Allpractices = [...this.Allpractices];
            }
          }
        }

        this.unlockSidebarIfLogoReady();
      },
      error: (err) => {
        // Initialize with empty arrays on error
        this.Recentpractices = [];
        this.Allpractices = [];
        this.isSidebarInteractive = true;
      }
    });
  }

  private unlockSidebarIfLogoReady(): void {
    const favoritePractice = this.Allpractices.find(practice => practice.favorite);
    if (!favoritePractice || !favoritePractice.firmLogo) {
      this.isSidebarInteractive = true;
    }
  }

  GetPracticeTimesheetdeatil() {     // Dev: Sachin yadav; Date: 16-07-2023,  CUST-2371
    this.firmDetailService.GetFirmTimeSheetSettingById().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result) {
        if (result.timeSheettype) {
          this._timesheeturl = '/manageprofile/managertimeSheet';
        } else {
          this._timesheeturl = '/manageprofile/timeSheet'
        }
      }
      localStorage.setItem('TimesheetPermission', JSON.stringify(result));
    });
  }

  OnpermissionSet() {
    if (this.menuPermissions != null) {
      let ClientSummary = this.menuPermissions.filter(f => f.area == 'Clients');
      if (ClientSummary.length > 0) {
        let cview = JSON.parse(ClientSummary[0].privilege)[0]; this.Clientprivilege = cview.Value;

        if (this.Clientprivilege == "True") {
          this.sclientlist = true;
          this.snewclientlist = true;
        }
        else {
          this.sclientlist = false;
          this.snewclientlist = false;
        }
      }
      let JobSummary = this.menuPermissions.filter(f => f.area == 'Jobs');
      if (JobSummary.length > 0) {
        let jview = JSON.parse(JobSummary[0].privilege)[0]; this.Jobsprivilege = jview.Value;
        if (this.Jobsprivilege == "True") {
          this.sJobspriv = true;
        }
        else {
          this.sJobspriv = false;
        }
      }
      let PlanningSummary = this.menuPermissions.filter(f => f.area == 'Planning');
      if (PlanningSummary.length > 0) {
        let pview = JSON.parse(PlanningSummary[0].privilege)[0]; this.Planningprivilege = pview.Value;
        if (this.Planningprivilege == "True") {
          this.sPlanning = true;
        }
        else {
          this.sPlanning = false;
        }
      }
      let DocSummary = this.menuPermissions.filter(f => f.area == 'Documents');
      if (DocSummary.length > 0) {
        let dview = JSON.parse(DocSummary[0].privilege)[0]; this.Docprivilege = dview.Value;
        if (this.Docprivilege == "True") {
          this.sDocpriv = true;
        }
        else {
          this.sDocpriv = false;
        }
      }

      let TimesheetSummary = this.menuPermissions.filter(f => f.area == 'Timesheet');
      let privilege = JSON.parse(TimesheetSummary[0].privilege)

      for (const element of privilege) {
        if (element.Key == 'Update') {
          this.uTimesheet = (element.Value == "True" ? true : false);
        }
        if (element.Key == 'Add') {
          this.aTimesheet = (element.Value == "True" ? true : false);
        }
      }

      let BillingSummary = this.menuPermissions.filter(f => f.area == 'Billing');
      privilege = JSON.parse(BillingSummary[0].privilege)

      for (let i = 0; i < privilege.length; i++) {
        if (privilege[i].Key == 'View') {
          this.sBilling = (privilege[i].Value == "True" ? true : false);
        }
        if (privilege[i].Key == 'WIPView') {
          this.sWIPView = (privilege[i].Value == "True" ? true : false);
        }
      }

      let ReportingSummary = this.menuPermissions.filter(f => f.area == 'Reportings');
      //Cust-9517: Anas Maniar Dt:10/02/2026
      if (ReportingSummary.length > 0) {
        const privileges = JSON.parse(ReportingSummary[0].privilege);
        const hasAnyReportEnabled = privileges.some(
          (p: any) => p.Value === 'True'
        );
        this.sReporting = hasAnyReportEnabled;
      }
      else {
        this.sReporting = false;
      }
      //Cust-9517: Anas Maniar Dt:10/02/2026

      let SettingSummary = this.menuPermissions.filter(f => f.area == 'Settings');
      if (SettingSummary.length > 0) {
        let sview = JSON.parse(SettingSummary[0].privilege)[0];
        this.Settingsprivilege = sview.Value;
        if (this.Settingsprivilege == "True") {
          this.sSettings = true;
        }
        else {
          this.sSettings = false;
        }
      }
    }
  }


  logout() {
    this.auth.logout().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      if (res) {
        this.router.navigate(['']);
      }
    })
  }

  FavoriteChange(tenants, id, dbkey) {
    if (this.Allpractices.length > 0 && this.Allpractices.filter(p => p.favorite && p.id === id).length <= 0) {
      this.router.navigate(['/dashboard']);    // default redirect to dashboard once we change Firm CUST-3799;  Dev Sachin Yadav; Date: 07-June-2024
      const useremail = localStorage.getItem('Email');
      this.firmDetailService.Updatefavorite(id, tenants, useremail).pipe(takeUntil(this.unsubscribe)).subscribe(result => {

      });
    }
  }

  OpenDashboardPopup() {
    this.bsModalRef = this.modalService.show(this.selectPracticePopup, {
      class: `modal-dialog-centered cmn-modal-dsgn modal-lg m-auto select-practice-popup`,
      backdrop: "static",
    });
  }

  CloseDashboardPopup() {
    this.bsModalRef.hide();
  }

  async setFeatureFlags() {
    this.isFeature = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.WorkflowList);
    this.isSettingFeature = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.SettingList);
    this.isTimeSheetFeature = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.Timesheet);
    this.isClientFeature = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.ClientList);
    this.isClientClassicFeature = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.ShowClientClassic);
    this.isBillingBetaFeature = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.ShowBillingBeta);
    this.isNewBillingFeature = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.ShowNewBilling);
  }

  isBillingActive(): boolean {                                          // Dev: Sasmit V; Date: 06-Jan-2025,  CUST-4857
    const currentUrl = (this.router.url || '').split('?')[0];
    return currentUrl.startsWith('/billing') && this.activeBillingMenu === 'billing';
  }

  isBillingSectionActive(): boolean {
    const currentUrl = (this.router.url || '').split('?')[0];
    return currentUrl.startsWith('/billing/') && this.activeBillingMenu === 'billing';
  }

  isBillingSubItemActive(section: 'wip' | 'invoicing' | 'planned' | 'payments' | 'bankStatements' | 'reconcile', menu: 'billing' | 'beta' = 'billing'): boolean {
    const userPermissions = JSON.parse(localStorage.getItem('UserPermissions'));
    const billing = JSON.parse(userPermissions.find((x: any) => x.area === 'Billing').privilege);
    this.isBillingPaymentEnabled = billing.find((p: any) => p.Key === 'Payment').Value == 'True' ? true : false;
    if (this.activeBillingMenu !== menu) {
      return false;
    }

    const parsedUrl = this.router.parseUrl(this.router.url || '/');
    const currentPath = parsedUrl.root.children['primary']
      ? '/' + parsedUrl.root.children['primary'].segments
          .map(s => s.path)
          .join('/')
      : '/';

    const queryParams = parsedUrl.queryParams || {};

    switch (section) {

      case 'wip':
        return (currentPath === (menu === 'beta' ? '/billing/billing-details' : '/billing/billings'))
          && !queryParams['showinvoice']
          && !queryParams['backPlannedInv']
          && !queryParams['backPayment'];

      case 'invoicing':
        return currentPath === (menu === 'beta' ? '/billing/billing-details/invoices' : '/billing/invoices');

      case 'planned':
        return currentPath === (menu === 'beta' ? '/billing/billing-details/planned-invoices' : '/billing/planned-invoices');

      case 'payments':
        return (currentPath === (menu === 'beta' ? '/billing/billing-details/payments' : '/billing/payments')
          || currentPath === (menu === 'beta' ? '/billing/billing-details/payments/reconcile' : '/billing/payments/reconcile')
          || currentPath === (menu === 'beta' ? '/billing/billing-details/payments/bank-statements' : '/billing/payments/bank-statements'))
          && !!queryParams['backPayment'];

      case 'bankStatements':
        return currentPath === (menu === 'beta' ? '/billing/billing-details/payments/bank-statements' : '/billing/payments/bank-statements');

      case 'reconcile':
        return currentPath === (menu === 'beta' ? '/billing/billing-details/payments/reconcile' : '/billing/payments/reconcile');

      default:
        return false;
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleShortcuts(event: KeyboardEvent): void {
    const key = event.code;

    if (!this.isSidebarInteractive) {
      return;
    }

    // =====================================================
    // FLOW 2: DIRECT SHORTCUT
    // Ctrl + Alt + Key
    // =====================================================

    if (event.ctrlKey && event.altKey) {
      const userPermissions = JSON.parse(localStorage.getItem('UserPermissions'));
      const billing = JSON.parse(userPermissions.find((x: any) => x.area === 'Billing').privilege);
      this.isBillingPaymentEnabled = billing.find((p: any) => p.Key === 'Payment').Value == 'True' ? true : false;

      switch (key) {

        case 'KeyB':
          if (this.sBilling || this.sWIPView) {
            event.preventDefault();
            event.stopPropagation();

            this.armBillingShortcut();
          }
          return;

        case 'KeyW':
          if (this.sBilling || this.sWIPView) {
            event.preventDefault();
            event.stopPropagation();

            this.clearBillingShortcutArm();
            this.navigateToBillingSection('wip');
          }
          return;

        case 'KeyI':
          if (this.sBilling || this.sWIPView) {
            event.preventDefault();
            event.stopPropagation();

            this.clearBillingShortcutArm();
            this.navigateToBillingSection('invoicing');
          }
          return;

        case 'KeyL':
          if (this.sBilling || this.sWIPView) {
            event.preventDefault();
            event.stopPropagation();

            this.clearBillingShortcutArm();
            this.navigateToBillingSection('planned');
          }
          return;

        case 'KeyP':
          if ((this.sBilling || this.sWIPView) && this.isBillingPaymentEnabled) {
            event.preventDefault();
            event.stopPropagation();

            this.armPaymentShortcut();
          }
          return;

        case 'KeyS':
          if (this.isBillingPaymentEnabled) {
            event.preventDefault();
            event.stopPropagation();

            this.clearBillingShortcutArm();
            this.navigateToBillingSection('bank-statements');
          }
          return;

        case 'KeyR':
          if (this.isBillingPaymentEnabled) {
            event.preventDefault();
            event.stopPropagation();

            this.clearBillingShortcutArm();
            this.navigateToBillingSection('reconcile');
          }
          return;
      }

      // Ctrl + Alt pressed without a shortcut key.
      // Activate shortcut mode.
      event.preventDefault();
      event.stopPropagation();

      this.billingShortcutArmed = true;
      this.showShortcutHints = true;

      return;
    }


    // =====================================================
    // FLOW 1: SEQUENTIAL SHORTCUT
    //
    // Ctrl + Alt
    //      ↓
    // release
    //      ↓
    // I
    // =====================================================

    if (!this.billingShortcutArmed) {
      return;
    }

    switch (key) {

      case 'KeyB':
        event.preventDefault();
        event.stopPropagation();

        this.armBillingShortcut();
        return;

      case 'KeyW':
        event.preventDefault();

        this.clearBillingShortcutArm();

        if (this.sBilling || this.sWIPView) {
          this.navigateToBillingSection('wip');
        }

        return;

      case 'KeyI':
        event.preventDefault();

        this.clearBillingShortcutArm();

        if (this.sBilling || this.sWIPView) {
          this.navigateToBillingSection('invoicing');
        }

        return;

      case 'KeyL':
        event.preventDefault();

        this.clearBillingShortcutArm();

        if (this.sBilling || this.sWIPView) {
          this.navigateToBillingSection('planned');
        }

        return;

      case 'KeyP':
        event.preventDefault();

        if ((this.sBilling || this.sWIPView) && this.isBillingPaymentEnabled) {
          this.armPaymentShortcut();
        }

        return;

      case 'KeyS':
        if (this.isPaymentShortcutOpen && this.isBillingPaymentEnabled) {
          event.preventDefault();

          this.clearBillingShortcutArm();
          this.navigateToBillingSection('bank-statements');
        }

        return;

      case 'KeyR':
        if (this.isPaymentShortcutOpen && this.isBillingPaymentEnabled) {
          event.preventDefault();

          this.clearBillingShortcutArm();
          this.navigateToBillingSection('reconcile');
        }

        return;

      case 'escape':
        event.preventDefault();

        this.clearBillingShortcutArm();
        return;
    }

    // Unknown key -> exit shortcut mode
    this.clearBillingShortcutArm();
  }

  @HostListener('window:blur')
  onWindowBlur(): void {
    this.clearBillingShortcutArm();
  }

  private armBillingShortcut(): void {
    this.billingShortcutArmed = true;
    this.positionBillingFlyoutFromSidebar();
    this.isBillingShortcutOpen = true;
    this.isPaymentShortcutOpen = false;
    if (this.billingShortcutTimer) {
      clearTimeout(this.billingShortcutTimer);
    }
    this.billingShortcutTimer = setTimeout(() => this.clearBillingShortcutArm(), 4000);
  }

  private armPaymentShortcut(): void {
    this.armBillingShortcut();
    this.isPaymentShortcutOpen = true;
  }

  private clearBillingShortcutArm(): void {
    this.billingShortcutArmed = false;
    this.isBillingShortcutOpen = false;
    this.isBillingBetaShortcutOpen = false;
    this.isPaymentShortcutOpen = false;
    this.showShortcutHints = false;
    if (!this.isBillingMenuHovered) {
      this.isBillingFlyoutUpward = false;
      this.billingFlyoutStyle = {};
    }
    if (!this.isBillingBetaMenuHovered) {
      this.isBillingBetaFlyoutUpward = false;
      this.billingBetaFlyoutStyle = {};
    }
    this.clearBillingHoverCloseTimer();
    this.clearBillingBetaHoverCloseTimer();
    if (this.billingShortcutTimer) {
      clearTimeout(this.billingShortcutTimer);
      this.billingShortcutTimer = null;
    }
  }

  onBillingMenuMouseEnter(event: MouseEvent): void {
    if (!this.isSidebarInteractive) {
      return;
    }

    this.closeBillingBetaFlyout();
    this.clearBillingHoverCloseTimer();
    this.isBillingMenuHovered = true;
    this.setBillingFlyoutPosition(event.currentTarget as HTMLElement);
    this.isBillingShortcutOpen = true;
  }

  onBillingMenuMouseLeave(): void {
    if (this.billingShortcutArmed) {
      return;
    }

    this.clearBillingHoverCloseTimer();
    this.billingHoverCloseTimer = setTimeout(() => {
      if (this.billingShortcutArmed) {
        return;
      }
      this.isBillingMenuHovered = false;
      this.isBillingShortcutOpen = false;
      this.isPaymentShortcutOpen = false;
      this.isBillingFlyoutUpward = false;
      this.billingFlyoutStyle = {};
      this.billingHoverCloseTimer = null;
    }, 120);
  }

  onBillingSubmenuMouseEnter(event: MouseEvent): void {
    this.clearBillingHoverCloseTimer();
    this.isBillingMenuHovered = true;
    const submenuElement = event.currentTarget as HTMLElement;
    const billingMenuElement = submenuElement?.closest('.billing-menu') as HTMLElement;
    this.setBillingFlyoutPosition(billingMenuElement);
    this.isBillingShortcutOpen = true;
  }

  onBillingSubmenuMouseLeave(event: MouseEvent): void {
    const submenuElement = event.currentTarget as HTMLElement;
    const billingMenuElement = submenuElement?.closest('.billing-menu');
    if (billingMenuElement?.contains(event.relatedTarget as Node)) {
      this.clearBillingHoverCloseTimer();
      return;
    }

    this.onBillingMenuMouseLeave();
  }

  private clearBillingHoverCloseTimer(): void {
    if (this.billingHoverCloseTimer) {
      clearTimeout(this.billingHoverCloseTimer);
      this.billingHoverCloseTimer = null;
    }
  }

  private closeBillingFlyout(): void {
    this.clearBillingHoverCloseTimer();
    this.isBillingMenuHovered = false;
    this.isBillingShortcutOpen = false;
    this.isBillingFlyoutUpward = false;
    this.billingFlyoutStyle = {};
  }

  //Billing Beta

  onBillingBetaMenuMouseEnter(event: MouseEvent): void {
    if (!this.isSidebarInteractive) {
      return;
    }

    this.closeBillingFlyout();
    this.clearBillingBetaHoverCloseTimer();
    this.isBillingBetaMenuHovered = true;
    this.setBillingBetaFlyoutPosition(event.currentTarget as HTMLElement);
    this.isBillingBetaShortcutOpen = true;
  }

  onBillingBetaMenuMouseLeave(): void {
    if (this.billingShortcutArmed) {
      return;
    }

    this.clearBillingBetaHoverCloseTimer();
    this.billingBetaHoverCloseTimer = setTimeout(() => {
      if (this.billingShortcutArmed) {
        return;
      }
      this.isBillingBetaMenuHovered = false;
      this.isBillingBetaShortcutOpen = false;
      this.isPaymentShortcutOpen = false;
      this.isBillingBetaFlyoutUpward = false;
      this.billingBetaFlyoutStyle = {};
      this.billingBetaHoverCloseTimer = null;
    }, 120);
  }

  onBillingBetaSubmenuMouseEnter(event: MouseEvent): void {
    this.clearBillingBetaHoverCloseTimer();
    this.isBillingBetaMenuHovered = true;
    const submenuElement = event.currentTarget as HTMLElement;
    const billingMenuElement = submenuElement?.closest('.billingbeta-menu') as HTMLElement;
    this.setBillingBetaFlyoutPosition(billingMenuElement);
    this.isBillingBetaShortcutOpen = true;
  }

  onBillingBetaSubmenuMouseLeave(event: MouseEvent): void {
    const submenuElement = event.currentTarget as HTMLElement;
    const billingMenuElement = submenuElement?.closest('.billingbeta-menu');
    if (billingMenuElement?.contains(event.relatedTarget as Node)) {
      this.clearBillingBetaHoverCloseTimer();
      return;
    }

    this.onBillingBetaMenuMouseLeave();
  }

  private clearBillingBetaHoverCloseTimer(): void {
    if (this.billingBetaHoverCloseTimer) {
      clearTimeout(this.billingBetaHoverCloseTimer);
      this.billingBetaHoverCloseTimer = null;
    }
  }

  private closeBillingBetaFlyout(): void {
    this.clearBillingBetaHoverCloseTimer();
    this.isBillingBetaMenuHovered = false;
    this.isBillingBetaShortcutOpen = false;
    this.isBillingBetaFlyoutUpward = false;
    this.billingBetaFlyoutStyle = {};
  }

  private setBillingFlyoutPosition(billingMenuElement: HTMLElement | null): void {
    if (!billingMenuElement || typeof window === 'undefined') {
      this.isBillingFlyoutUpward = false;
      this.billingFlyoutStyle = {};
      return;
    }

    const flyoutElement = billingMenuElement.querySelector(':scope > ul') as HTMLElement | null;
    const flyoutHeight = flyoutElement?.offsetHeight || 185;
    const topOffset = 5;
    const safeMargin = 12;
    const hostRect = billingMenuElement.getBoundingClientRect();
    const downTop = hostRect.top + topOffset;
    const spaceBelow = window.innerHeight - downTop;
    const shouldOpenUp = spaceBelow < flyoutHeight + safeMargin;
    const resolvedTop = shouldOpenUp
      ? Math.max(safeMargin, hostRect.bottom - flyoutHeight)
      : Math.min(downTop, window.innerHeight - flyoutHeight - safeMargin);
    const resolvedLeft = hostRect.right + 1;

    this.isBillingFlyoutUpward = shouldOpenUp;
    this.billingFlyoutStyle = {
      left: `${resolvedLeft}px`,
      top: `${resolvedTop}px`
    };
  }

  private positionBillingFlyoutFromSidebar(): void {
    if (typeof document === 'undefined') {
      return;
    }

    const billingMenuElement = document.querySelector('.side-Navigation .billing-menu') as HTMLElement | null;
    this.setBillingFlyoutPosition(billingMenuElement);
  }

  private setBillingBetaFlyoutPosition(billingMenuElement: HTMLElement | null): void {
    if (!billingMenuElement || typeof window === 'undefined') {
      this.isBillingBetaFlyoutUpward = false;
      this.billingBetaFlyoutStyle = {};
      return;
    }

    const flyoutElement = billingMenuElement.querySelector(':scope > ul') as HTMLElement | null;
    const flyoutHeight = flyoutElement?.offsetHeight || 215;
    const topOffset = 5;
    const safeMargin = 12;
    const hostRect = billingMenuElement.getBoundingClientRect();
    const downTop = hostRect.top + topOffset;
    const spaceBelow = window.innerHeight - downTop;
    const shouldOpenUp = spaceBelow < flyoutHeight + safeMargin;
    const resolvedTop = shouldOpenUp
      ? Math.max(safeMargin, hostRect.bottom - flyoutHeight)
      : Math.min(downTop, window.innerHeight - flyoutHeight - safeMargin);
    const resolvedLeft = hostRect.right + 1;

    this.isBillingBetaFlyoutUpward = shouldOpenUp;
    this.billingBetaFlyoutStyle = {
      left: `${resolvedLeft}px`,
      top: `${resolvedTop}px`
    };
  }

  private positionBillingBetaFlyoutFromSidebar(): void {
    if (typeof document === 'undefined') {
      return;
    }

    const billingMenuElement = document.querySelector('.side-Navigation .billingbeta-menu') as HTMLElement | null;
    this.setBillingBetaFlyoutPosition(billingMenuElement);
  }

  private navigateToBillingSection(section: 'wip' | 'invoicing' | 'planned' | 'payments' | 'bank-statements' | 'reconcile'): void {
    if (!(this.sBilling || this.sWIPView)) {
      return;
    }

    this.commonService.startNewNavigation();
    if (section === 'wip') {
      this.router.navigate(['/billing/billings']);
      return;
    }

    if (section === 'invoicing') {
      this.router.navigate(['/billing/invoices']);
      return;
    }

    if (section === 'planned') {
      this.router.navigate(['/billing/planned-invoices']);
      return;
    }

    if (section === 'bank-statements') {
      this.router.navigate(['/billing/payments/bank-statements']);
      return;
    }

    if (section === 'reconcile') {
      this.router.navigate(['/billing/payments/reconcile']);
      return;
    }

    this.router.navigate(['/billing/payments']);
  }

  isBillingBetaActive(): boolean {
      const currentUrl = (this.router.url || '').split('?')[0];
      return currentUrl.startsWith('/billing') && this.activeBillingMenu === 'beta';
  }

  getDMSProvider() {
    const dmsProviderType = localStorage.getItem('DMSProviderType') || null;
    this.dmsProviderKeys = {
      dmsProviderType: dmsProviderType,
      dmsProviderUrl: dmsProviderType === DMS_PROVIDER_TYPE.SharePoint ? '/dms/auth' : '/document',
      isIManageFirm: dmsProviderType === DMS_PROVIDER_TYPE.IManage,
      isActiveFirm: dmsProviderType === DMS_PROVIDER_TYPE.Active
    }
  }

  closeSubMenu(menuTrigger: MatMenuTrigger) {
    if (menuTrigger) {
      menuTrigger.closeMenu();
    }
  }

  onFavoriteLogoLoad(): void {
    this.isSidebarInteractive = true;
  }

  onFavoriteLogoError(event: any): void {
    this.onImageError(event);
    this.isSidebarInteractive = true;
  }

  onImageError(event: any) {
    event.target.src = '../../../../assets/img/ImagesOnly/sampleImage.png';
  }

  onDocumentsTabClick(event: MouseEvent) {
    if (!this.isSidebarInteractive) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (this.dmsProviderKeys?.isIManageFirm) {
      window.open(IMANAGE_PROVIDER_PORTAL_URL, '_blank');
    } else if (this.dmsProviderKeys?.isActiveFirm) {
      this.activeDocumentsRedirection();
    } else {
      const targetUrl = this.dmsProviderKeys?.dmsProviderUrl || '/document';
      if (this.onMenuNavigationClick(event, targetUrl)) {
        this.router.navigate([targetUrl]);
      }
    }
  }

  activeDocumentsRedirection() {
    const entityType = 'All';
    const entityCode = 'Documents';
    const connectionType = 'Active';
    const connectionId = '00000000-0000-0000-0000-000000000000';
    const clientId = '0';
    const moduleName = 'Documents';

    this.xeroService.getDocumentsRedirectUrl(entityType, entityCode, connectionType, connectionId, clientId, moduleName)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (redirectUrl: string) => {
          if (redirectUrl) {
            window.open(redirectUrl, '_blank');
          }
        },
        error: (error) => {
          this._toastr.error('Error redirecting to documents:', 'Error');
        }
      });
  }

  ngOnDestroy() {
    this.clearBillingShortcutArm();
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.sub.unsubscribe();
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
  //#endregion
}
